const WAITING = 'Waiting';
const APPROVED = 'Approved';
const REPROVED = 'Reproved';
const WORKING = 'Working';
const DONE = 'Done';
const REVISION = 'Waiting for revision';
const WAITPUBLISHING = 'Waiting for publishing';
const PUBLISHED = 'Published';
const PREREVISION = 'Preparing for revision';
const ONHOLD = 'On Hold';
const RETURNTOWRITER = 'Return to writer';
const REVIEWPAUSED = 'Review paused';
const WAITINGFORTRANSLATION = 'Waiting for translation';
const ERRORWHENTRANSLATION = 'Error when translating';
const INTRANSLATION = 'In translation';
const SCHEDULED = 'Scheduled';
const AIWRITING = 'AI Writing';
const AIERROR = 'AI Error';
const AWAITINGAIWRITING = 'Awaiting AI Writing';
const ALL = 'All';

export {
  ALL,
  WAITING,
  APPROVED,
  REPROVED,
  WORKING,
  DONE,
  REVISION,
  WAITPUBLISHING,
  PUBLISHED,
  PREREVISION,
  ONHOLD,
  RETURNTOWRITER,
  REVIEWPAUSED,
  WAITINGFORTRANSLATION,
  ERRORWHENTRANSLATION,
  INTRANSLATION,
  SCHEDULED,
  AIWRITING,
  AIERROR,
  AWAITINGAIWRITING,
};

export const Status = {
  WAITING: 'Waiting',
  APPROVED: 'Approved',
  REPROVED: 'Reproved',
  WORKING: 'Working',
  DONE: 'Done',
  REVISION: 'Waiting for revision',
  WAITPUBLISHING: 'Waiting for publishing',
  PUBLISHED: 'Published',
  PREREVISION: 'Preparing for revision',
  ONHOLD: 'On Hold',
  RETURNTOWRITER: 'Return to writer',
  REVIEWPAUSED: 'Review paused',
  WAITINGFORTRANSLATION: 'Waiting for translation',
  ERRORWHENTRANSLATION: 'Error when translating',
  INTRANSLATION: 'In translation',
  SCHEDULED: 'Scheduled',
  AIWRITING: 'AI Writing',
  AIERROR: 'AI Error',
  AWAITINGAIWRITING: 'Awaiting AI Writing',
};
